export const enum ChallengeAttemptStatusEnum {
  ARCHIVED = 'archived',
  FAILED = 'failed',
  PASSED = 'passed',
  PENDING = 'pending',
  SUBMITTED = 'submitted',
};
